import React, { useEffect, useState } from 'react'

import SideList from '../../../components/SideList/SideList'
import { contactService } from '../../../../services/contactService'

const AgencyContactsList = () => {
    const [contacts, setContacts] = useState([])

    useEffect(() => {
        const getContacts = async () => {
            try {
                const contacts = await contactService.getContacts('agencija')

                setContacts(contacts)
            } catch (e) {
                console.error(e)
            }
        }
        getContacts()
    }, [])

    const onSearch = async (searchTerm) => {
        try {
            const contactsList = await contactService.searchContacts(searchTerm)
            setContacts(contactsList)
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <>
            <SideList list={contacts} editLinkPath="/kontakti/predstavnistva-i-agencije" onSearch={onSearch} />
        </>
    )
}

export default AgencyContactsList
